/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'tools.ozone.report.defs'

type $nsid = typeof $nsid

export { $nsid }

type ReasonType =
  | 'tools.ozone.report.defs#reasonAppeal'
  | 'tools.ozone.report.defs#reasonOther'
  | 'tools.ozone.report.defs#reasonViolenceAnimal'
  | 'tools.ozone.report.defs#reasonViolenceThreats'
  | 'tools.ozone.report.defs#reasonViolenceGraphicContent'
  | 'tools.ozone.report.defs#reasonViolenceGlorification'
  | 'tools.ozone.report.defs#reasonViolenceExtremistContent'
  | 'tools.ozone.report.defs#reasonViolenceTrafficking'
  | 'tools.ozone.report.defs#reasonViolenceOther'
  | 'tools.ozone.report.defs#reasonSexualAbuseContent'
  | 'tools.ozone.report.defs#reasonSexualNCII'
  | 'tools.ozone.report.defs#reasonSexualDeepfake'
  | 'tools.ozone.report.defs#reasonSexualAnimal'
  | 'tools.ozone.report.defs#reasonSexualUnlabeled'
  | 'tools.ozone.report.defs#reasonSexualOther'
  | 'tools.ozone.report.defs#reasonChildSafetyCSAM'
  | 'tools.ozone.report.defs#reasonChildSafetyGroom'
  | 'tools.ozone.report.defs#reasonChildSafetyPrivacy'
  | 'tools.ozone.report.defs#reasonChildSafetyHarassment'
  | 'tools.ozone.report.defs#reasonChildSafetyOther'
  | 'tools.ozone.report.defs#reasonHarassmentTroll'
  | 'tools.ozone.report.defs#reasonHarassmentTargeted'
  | 'tools.ozone.report.defs#reasonHarassmentHateSpeech'
  | 'tools.ozone.report.defs#reasonHarassmentDoxxing'
  | 'tools.ozone.report.defs#reasonHarassmentOther'
  | 'tools.ozone.report.defs#reasonMisleadingBot'
  | 'tools.ozone.report.defs#reasonMisleadingImpersonation'
  | 'tools.ozone.report.defs#reasonMisleadingSpam'
  | 'tools.ozone.report.defs#reasonMisleadingScam'
  | 'tools.ozone.report.defs#reasonMisleadingElections'
  | 'tools.ozone.report.defs#reasonMisleadingOther'
  | 'tools.ozone.report.defs#reasonRuleSiteSecurity'
  | 'tools.ozone.report.defs#reasonRuleProhibitedSales'
  | 'tools.ozone.report.defs#reasonRuleBanEvasion'
  | 'tools.ozone.report.defs#reasonRuleOther'
  | 'tools.ozone.report.defs#reasonSelfHarmContent'
  | 'tools.ozone.report.defs#reasonSelfHarmED'
  | 'tools.ozone.report.defs#reasonSelfHarmStunts'
  | 'tools.ozone.report.defs#reasonSelfHarmSubstances'
  | 'tools.ozone.report.defs#reasonSelfHarmOther'
  | l.UnknownString

export type { ReasonType }

const reasonType = /*#__PURE__*/ l.string<{
  knownValues: [
    'tools.ozone.report.defs#reasonAppeal',
    'tools.ozone.report.defs#reasonOther',
    'tools.ozone.report.defs#reasonViolenceAnimal',
    'tools.ozone.report.defs#reasonViolenceThreats',
    'tools.ozone.report.defs#reasonViolenceGraphicContent',
    'tools.ozone.report.defs#reasonViolenceGlorification',
    'tools.ozone.report.defs#reasonViolenceExtremistContent',
    'tools.ozone.report.defs#reasonViolenceTrafficking',
    'tools.ozone.report.defs#reasonViolenceOther',
    'tools.ozone.report.defs#reasonSexualAbuseContent',
    'tools.ozone.report.defs#reasonSexualNCII',
    'tools.ozone.report.defs#reasonSexualDeepfake',
    'tools.ozone.report.defs#reasonSexualAnimal',
    'tools.ozone.report.defs#reasonSexualUnlabeled',
    'tools.ozone.report.defs#reasonSexualOther',
    'tools.ozone.report.defs#reasonChildSafetyCSAM',
    'tools.ozone.report.defs#reasonChildSafetyGroom',
    'tools.ozone.report.defs#reasonChildSafetyPrivacy',
    'tools.ozone.report.defs#reasonChildSafetyHarassment',
    'tools.ozone.report.defs#reasonChildSafetyOther',
    'tools.ozone.report.defs#reasonHarassmentTroll',
    'tools.ozone.report.defs#reasonHarassmentTargeted',
    'tools.ozone.report.defs#reasonHarassmentHateSpeech',
    'tools.ozone.report.defs#reasonHarassmentDoxxing',
    'tools.ozone.report.defs#reasonHarassmentOther',
    'tools.ozone.report.defs#reasonMisleadingBot',
    'tools.ozone.report.defs#reasonMisleadingImpersonation',
    'tools.ozone.report.defs#reasonMisleadingSpam',
    'tools.ozone.report.defs#reasonMisleadingScam',
    'tools.ozone.report.defs#reasonMisleadingElections',
    'tools.ozone.report.defs#reasonMisleadingOther',
    'tools.ozone.report.defs#reasonRuleSiteSecurity',
    'tools.ozone.report.defs#reasonRuleProhibitedSales',
    'tools.ozone.report.defs#reasonRuleBanEvasion',
    'tools.ozone.report.defs#reasonRuleOther',
    'tools.ozone.report.defs#reasonSelfHarmContent',
    'tools.ozone.report.defs#reasonSelfHarmED',
    'tools.ozone.report.defs#reasonSelfHarmStunts',
    'tools.ozone.report.defs#reasonSelfHarmSubstances',
    'tools.ozone.report.defs#reasonSelfHarmOther',
  ]
}>()

export { reasonType }

/** An issue not included in these options */
const reasonOther = /*#__PURE__*/ l.token($nsid, 'reasonOther')

export { reasonOther }

/** An issue not included in these options */
const ReasonOther = /*#__PURE__*/ reasonOther.value

/** An issue not included in these options */
type ReasonOther = typeof ReasonOther

export { ReasonOther }

/** Appeal a previously taken moderation action */
const reasonAppeal = /*#__PURE__*/ l.token($nsid, 'reasonAppeal')

export { reasonAppeal }

/** Appeal a previously taken moderation action */
const ReasonAppeal = /*#__PURE__*/ reasonAppeal.value

/** Appeal a previously taken moderation action */
type ReasonAppeal = typeof ReasonAppeal

export { ReasonAppeal }

/** Other */
const reasonRuleOther = /*#__PURE__*/ l.token($nsid, 'reasonRuleOther')

export { reasonRuleOther }

/** Other */
const ReasonRuleOther = /*#__PURE__*/ reasonRuleOther.value

/** Other */
type ReasonRuleOther = typeof ReasonRuleOther

export { ReasonRuleOther }

/** Eating disorders */
const reasonSelfHarmED = /*#__PURE__*/ l.token($nsid, 'reasonSelfHarmED')

export { reasonSelfHarmED }

/** Eating disorders */
const ReasonSelfHarmEd = /*#__PURE__*/ reasonSelfHarmED.value

/** Eating disorders */
type ReasonSelfHarmEd = typeof ReasonSelfHarmEd

export { ReasonSelfHarmEd }

/** Non-consensual intimate imagery */
const reasonSexualNCII = /*#__PURE__*/ l.token($nsid, 'reasonSexualNCII')

export { reasonSexualNCII }

/** Non-consensual intimate imagery */
const ReasonSexualNcii = /*#__PURE__*/ reasonSexualNCII.value

/** Non-consensual intimate imagery */
type ReasonSexualNcii = typeof ReasonSexualNcii

export { ReasonSexualNcii }

/** Other sexual violence content */
const reasonSexualOther = /*#__PURE__*/ l.token($nsid, 'reasonSexualOther')

export { reasonSexualOther }

/** Other sexual violence content */
const ReasonSexualOther = /*#__PURE__*/ reasonSexualOther.value

/** Other sexual violence content */
type ReasonSexualOther = typeof ReasonSexualOther

export { ReasonSexualOther }

/** Animal sexual abuse */
const reasonSexualAnimal = /*#__PURE__*/ l.token($nsid, 'reasonSexualAnimal')

export { reasonSexualAnimal }

/** Animal sexual abuse */
const ReasonSexualAnimal = /*#__PURE__*/ reasonSexualAnimal.value

/** Animal sexual abuse */
type ReasonSexualAnimal = typeof ReasonSexualAnimal

export { ReasonSexualAnimal }

/** Fake account or bot */
const reasonMisleadingBot = /*#__PURE__*/ l.token($nsid, 'reasonMisleadingBot')

export { reasonMisleadingBot }

/** Fake account or bot */
const ReasonMisleadingBot = /*#__PURE__*/ reasonMisleadingBot.value

/** Fake account or bot */
type ReasonMisleadingBot = typeof ReasonMisleadingBot

export { ReasonMisleadingBot }

/** Other dangerous content */
const reasonSelfHarmOther = /*#__PURE__*/ l.token($nsid, 'reasonSelfHarmOther')

export { reasonSelfHarmOther }

/** Other dangerous content */
const ReasonSelfHarmOther = /*#__PURE__*/ reasonSelfHarmOther.value

/** Other dangerous content */
type ReasonSelfHarmOther = typeof ReasonSelfHarmOther

export { ReasonSelfHarmOther }

/** Other violent content */
const reasonViolenceOther = /*#__PURE__*/ l.token($nsid, 'reasonViolenceOther')

export { reasonViolenceOther }

/** Other violent content */
const ReasonViolenceOther = /*#__PURE__*/ reasonViolenceOther.value

/** Other violent content */
type ReasonViolenceOther = typeof ReasonViolenceOther

export { ReasonViolenceOther }

/** Scam */
const reasonMisleadingScam = /*#__PURE__*/ l.token(
  $nsid,
  'reasonMisleadingScam',
)

export { reasonMisleadingScam }

/** Scam */
const ReasonMisleadingScam = /*#__PURE__*/ reasonMisleadingScam.value

/** Scam */
type ReasonMisleadingScam = typeof ReasonMisleadingScam

export { ReasonMisleadingScam }

/** Spam */
const reasonMisleadingSpam = /*#__PURE__*/ l.token(
  $nsid,
  'reasonMisleadingSpam',
)

export { reasonMisleadingSpam }

/** Spam */
const ReasonMisleadingSpam = /*#__PURE__*/ reasonMisleadingSpam.value

/** Spam */
type ReasonMisleadingSpam = typeof ReasonMisleadingSpam

export { ReasonMisleadingSpam }

/** Banned user returning */
const reasonRuleBanEvasion = /*#__PURE__*/ l.token(
  $nsid,
  'reasonRuleBanEvasion',
)

export { reasonRuleBanEvasion }

/** Banned user returning */
const ReasonRuleBanEvasion = /*#__PURE__*/ reasonRuleBanEvasion.value

/** Banned user returning */
type ReasonRuleBanEvasion = typeof ReasonRuleBanEvasion

export { ReasonRuleBanEvasion }

/** Dangerous challenges or activities */
const reasonSelfHarmStunts = /*#__PURE__*/ l.token(
  $nsid,
  'reasonSelfHarmStunts',
)

export { reasonSelfHarmStunts }

/** Dangerous challenges or activities */
const ReasonSelfHarmStunts = /*#__PURE__*/ reasonSelfHarmStunts.value

/** Dangerous challenges or activities */
type ReasonSelfHarmStunts = typeof ReasonSelfHarmStunts

export { ReasonSelfHarmStunts }

/** Deepfake adult content */
const reasonSexualDeepfake = /*#__PURE__*/ l.token(
  $nsid,
  'reasonSexualDeepfake',
)

export { reasonSexualDeepfake }

/** Deepfake adult content */
const ReasonSexualDeepfake = /*#__PURE__*/ reasonSexualDeepfake.value

/** Deepfake adult content */
type ReasonSexualDeepfake = typeof ReasonSexualDeepfake

export { ReasonSexualDeepfake }

/** Animal welfare violations */
const reasonViolenceAnimal = /*#__PURE__*/ l.token(
  $nsid,
  'reasonViolenceAnimal',
)

export { reasonViolenceAnimal }

/** Animal welfare violations */
const ReasonViolenceAnimal = /*#__PURE__*/ reasonViolenceAnimal.value

/** Animal welfare violations */
type ReasonViolenceAnimal = typeof ReasonViolenceAnimal

export { ReasonViolenceAnimal }

/** Child sexual abuse material (CSAM). These reports will be sent only be sent to the application's Moderation Authority. */
const reasonChildSafetyCSAM = /*#__PURE__*/ l.token(
  $nsid,
  'reasonChildSafetyCSAM',
)

export { reasonChildSafetyCSAM }

/** Child sexual abuse material (CSAM). These reports will be sent only be sent to the application's Moderation Authority. */
const ReasonChildSafetyCsam = /*#__PURE__*/ reasonChildSafetyCSAM.value

/** Child sexual abuse material (CSAM). These reports will be sent only be sent to the application's Moderation Authority. */
type ReasonChildSafetyCsam = typeof ReasonChildSafetyCsam

export { ReasonChildSafetyCsam }

/** Other harassing or hateful content */
const reasonHarassmentOther = /*#__PURE__*/ l.token(
  $nsid,
  'reasonHarassmentOther',
)

export { reasonHarassmentOther }

/** Other harassing or hateful content */
const ReasonHarassmentOther = /*#__PURE__*/ reasonHarassmentOther.value

/** Other harassing or hateful content */
type ReasonHarassmentOther = typeof ReasonHarassmentOther

export { ReasonHarassmentOther }

/** Trolling */
const reasonHarassmentTroll = /*#__PURE__*/ l.token(
  $nsid,
  'reasonHarassmentTroll',
)

export { reasonHarassmentTroll }

/** Trolling */
const ReasonHarassmentTroll = /*#__PURE__*/ reasonHarassmentTroll.value

/** Trolling */
type ReasonHarassmentTroll = typeof ReasonHarassmentTroll

export { ReasonHarassmentTroll }

/** Other misleading content */
const reasonMisleadingOther = /*#__PURE__*/ l.token(
  $nsid,
  'reasonMisleadingOther',
)

export { reasonMisleadingOther }

/** Other misleading content */
const ReasonMisleadingOther = /*#__PURE__*/ reasonMisleadingOther.value

/** Other misleading content */
type ReasonMisleadingOther = typeof ReasonMisleadingOther

export { ReasonMisleadingOther }

/** Content promoting or depicting self-harm */
const reasonSelfHarmContent = /*#__PURE__*/ l.token(
  $nsid,
  'reasonSelfHarmContent',
)

export { reasonSelfHarmContent }

/** Content promoting or depicting self-harm */
const ReasonSelfHarmContent = /*#__PURE__*/ reasonSelfHarmContent.value

/** Content promoting or depicting self-harm */
type ReasonSelfHarmContent = typeof ReasonSelfHarmContent

export { ReasonSelfHarmContent }

/** Unlabelled adult content */
const reasonSexualUnlabeled = /*#__PURE__*/ l.token(
  $nsid,
  'reasonSexualUnlabeled',
)

export { reasonSexualUnlabeled }

/** Unlabelled adult content */
const ReasonSexualUnlabeled = /*#__PURE__*/ reasonSexualUnlabeled.value

/** Unlabelled adult content */
type ReasonSexualUnlabeled = typeof ReasonSexualUnlabeled

export { ReasonSexualUnlabeled }

/** Threats or incitement */
const reasonViolenceThreats = /*#__PURE__*/ l.token(
  $nsid,
  'reasonViolenceThreats',
)

export { reasonViolenceThreats }

/** Threats or incitement */
const ReasonViolenceThreats = /*#__PURE__*/ reasonViolenceThreats.value

/** Threats or incitement */
type ReasonViolenceThreats = typeof ReasonViolenceThreats

export { ReasonViolenceThreats }

/** Grooming or predatory behavior. These reports will be sent only be sent to the application's Moderation Authority. */
const reasonChildSafetyGroom = /*#__PURE__*/ l.token(
  $nsid,
  'reasonChildSafetyGroom',
)

export { reasonChildSafetyGroom }

/** Grooming or predatory behavior. These reports will be sent only be sent to the application's Moderation Authority. */
const ReasonChildSafetyGroom = /*#__PURE__*/ reasonChildSafetyGroom.value

/** Grooming or predatory behavior. These reports will be sent only be sent to the application's Moderation Authority. */
type ReasonChildSafetyGroom = typeof ReasonChildSafetyGroom

export { ReasonChildSafetyGroom }

/** Other child safety. These reports will be sent only be sent to the application's Moderation Authority. */
const reasonChildSafetyOther = /*#__PURE__*/ l.token(
  $nsid,
  'reasonChildSafetyOther',
)

export { reasonChildSafetyOther }

/** Other child safety. These reports will be sent only be sent to the application's Moderation Authority. */
const ReasonChildSafetyOther = /*#__PURE__*/ reasonChildSafetyOther.value

/** Other child safety. These reports will be sent only be sent to the application's Moderation Authority. */
type ReasonChildSafetyOther = typeof ReasonChildSafetyOther

export { ReasonChildSafetyOther }

/** Hacking or system attacks */
const reasonRuleSiteSecurity = /*#__PURE__*/ l.token(
  $nsid,
  'reasonRuleSiteSecurity',
)

export { reasonRuleSiteSecurity }

/** Hacking or system attacks */
const ReasonRuleSiteSecurity = /*#__PURE__*/ reasonRuleSiteSecurity.value

/** Hacking or system attacks */
type ReasonRuleSiteSecurity = typeof ReasonRuleSiteSecurity

export { ReasonRuleSiteSecurity }

/** Doxxing */
const reasonHarassmentDoxxing = /*#__PURE__*/ l.token(
  $nsid,
  'reasonHarassmentDoxxing',
)

export { reasonHarassmentDoxxing }

/** Doxxing */
const ReasonHarassmentDoxxing = /*#__PURE__*/ reasonHarassmentDoxxing.value

/** Doxxing */
type ReasonHarassmentDoxxing = typeof ReasonHarassmentDoxxing

export { ReasonHarassmentDoxxing }

/** Privacy violation involving a minor */
const reasonChildSafetyPrivacy = /*#__PURE__*/ l.token(
  $nsid,
  'reasonChildSafetyPrivacy',
)

export { reasonChildSafetyPrivacy }

/** Privacy violation involving a minor */
const ReasonChildSafetyPrivacy = /*#__PURE__*/ reasonChildSafetyPrivacy.value

/** Privacy violation involving a minor */
type ReasonChildSafetyPrivacy = typeof ReasonChildSafetyPrivacy

export { ReasonChildSafetyPrivacy }

/** Targeted harassment */
const reasonHarassmentTargeted = /*#__PURE__*/ l.token(
  $nsid,
  'reasonHarassmentTargeted',
)

export { reasonHarassmentTargeted }

/** Targeted harassment */
const ReasonHarassmentTargeted = /*#__PURE__*/ reasonHarassmentTargeted.value

/** Targeted harassment */
type ReasonHarassmentTargeted = typeof ReasonHarassmentTargeted

export { ReasonHarassmentTargeted }

/** Dangerous substances or drug abuse */
const reasonSelfHarmSubstances = /*#__PURE__*/ l.token(
  $nsid,
  'reasonSelfHarmSubstances',
)

export { reasonSelfHarmSubstances }

/** Dangerous substances or drug abuse */
const ReasonSelfHarmSubstances = /*#__PURE__*/ reasonSelfHarmSubstances.value

/** Dangerous substances or drug abuse */
type ReasonSelfHarmSubstances = typeof ReasonSelfHarmSubstances

export { ReasonSelfHarmSubstances }

/** Adult sexual abuse content */
const reasonSexualAbuseContent = /*#__PURE__*/ l.token(
  $nsid,
  'reasonSexualAbuseContent',
)

export { reasonSexualAbuseContent }

/** Adult sexual abuse content */
const ReasonSexualAbuseContent = /*#__PURE__*/ reasonSexualAbuseContent.value

/** Adult sexual abuse content */
type ReasonSexualAbuseContent = typeof ReasonSexualAbuseContent

export { ReasonSexualAbuseContent }

/** False information about elections */
const reasonMisleadingElections = /*#__PURE__*/ l.token(
  $nsid,
  'reasonMisleadingElections',
)

export { reasonMisleadingElections }

/** False information about elections */
const ReasonMisleadingElections = /*#__PURE__*/ reasonMisleadingElections.value

/** False information about elections */
type ReasonMisleadingElections = typeof ReasonMisleadingElections

export { ReasonMisleadingElections }

/** Promoting or selling prohibited items or services */
const reasonRuleProhibitedSales = /*#__PURE__*/ l.token(
  $nsid,
  'reasonRuleProhibitedSales',
)

export { reasonRuleProhibitedSales }

/** Promoting or selling prohibited items or services */
const ReasonRuleProhibitedSales = /*#__PURE__*/ reasonRuleProhibitedSales.value

/** Promoting or selling prohibited items or services */
type ReasonRuleProhibitedSales = typeof ReasonRuleProhibitedSales

export { ReasonRuleProhibitedSales }

/** Human trafficking */
const reasonViolenceTrafficking = /*#__PURE__*/ l.token(
  $nsid,
  'reasonViolenceTrafficking',
)

export { reasonViolenceTrafficking }

/** Human trafficking */
const ReasonViolenceTrafficking = /*#__PURE__*/ reasonViolenceTrafficking.value

/** Human trafficking */
type ReasonViolenceTrafficking = typeof ReasonViolenceTrafficking

export { ReasonViolenceTrafficking }

/** Hate speech */
const reasonHarassmentHateSpeech = /*#__PURE__*/ l.token(
  $nsid,
  'reasonHarassmentHateSpeech',
)

export { reasonHarassmentHateSpeech }

/** Hate speech */
const ReasonHarassmentHateSpeech =
  /*#__PURE__*/ reasonHarassmentHateSpeech.value

/** Hate speech */
type ReasonHarassmentHateSpeech = typeof ReasonHarassmentHateSpeech

export { ReasonHarassmentHateSpeech }

/** Harassment or bullying of minors */
const reasonChildSafetyHarassment = /*#__PURE__*/ l.token(
  $nsid,
  'reasonChildSafetyHarassment',
)

export { reasonChildSafetyHarassment }

/** Harassment or bullying of minors */
const ReasonChildSafetyHarassment =
  /*#__PURE__*/ reasonChildSafetyHarassment.value

/** Harassment or bullying of minors */
type ReasonChildSafetyHarassment = typeof ReasonChildSafetyHarassment

export { ReasonChildSafetyHarassment }

/** Glorification of violence */
const reasonViolenceGlorification = /*#__PURE__*/ l.token(
  $nsid,
  'reasonViolenceGlorification',
)

export { reasonViolenceGlorification }

/** Glorification of violence */
const ReasonViolenceGlorification =
  /*#__PURE__*/ reasonViolenceGlorification.value

/** Glorification of violence */
type ReasonViolenceGlorification = typeof ReasonViolenceGlorification

export { ReasonViolenceGlorification }

/** Graphic violent content */
const reasonViolenceGraphicContent = /*#__PURE__*/ l.token(
  $nsid,
  'reasonViolenceGraphicContent',
)

export { reasonViolenceGraphicContent }

/** Graphic violent content */
const ReasonViolenceGraphicContent =
  /*#__PURE__*/ reasonViolenceGraphicContent.value

/** Graphic violent content */
type ReasonViolenceGraphicContent = typeof ReasonViolenceGraphicContent

export { ReasonViolenceGraphicContent }

/** Impersonation */
const reasonMisleadingImpersonation = /*#__PURE__*/ l.token(
  $nsid,
  'reasonMisleadingImpersonation',
)

export { reasonMisleadingImpersonation }

/** Impersonation */
const ReasonMisleadingImpersonation =
  /*#__PURE__*/ reasonMisleadingImpersonation.value

/** Impersonation */
type ReasonMisleadingImpersonation = typeof ReasonMisleadingImpersonation

export { ReasonMisleadingImpersonation }

/** Extremist content. These reports will be sent only be sent to the application's Moderation Authority. */
const reasonViolenceExtremistContent = /*#__PURE__*/ l.token(
  $nsid,
  'reasonViolenceExtremistContent',
)

export { reasonViolenceExtremistContent }

/** Extremist content. These reports will be sent only be sent to the application's Moderation Authority. */
const ReasonViolenceExtremistContent =
  /*#__PURE__*/ reasonViolenceExtremistContent.value

/** Extremist content. These reports will be sent only be sent to the application's Moderation Authority. */
type ReasonViolenceExtremistContent = typeof ReasonViolenceExtremistContent

export { ReasonViolenceExtremistContent }
